function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "16.41 24.04 477.92 455.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407,48.67s-54.24-40.07-123.57-18-97.53,81.71-136.81,123.64c-20.58,22-51.34,31.12-75.92,48.42-78.61,55.32-64.95,171-3,212,53.66,35.53,120,36.47,205.78,4.53s147.22-51.57,199.4-134.2S473.85,103.37,407,48.67Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,48.67s-54.24-40.07-123.57-18-97.53,81.71-136.81,123.64c-20.58,22-51.34,31.12-75.92,48.42-78.61,55.32-64.95,171-3,212,53.66,35.53,120,36.47,205.78,4.53s147.22-51.57,199.4-134.2S473.85,103.37,407,48.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 408.1,
    y1: 345.48,
    x2: 418.23,
    y2: 442.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.59,
    y1: 423.93,
    x2: 412,
    y2: 419.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.4,420.54a5.21,5.21,0,0,0-1.83-3.9c-1.18-1.05-7.38-3.66-8-1.47C403,417.54,409.31,422.21,413.4,420.54Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.4,
    y1: 420.54,
    x2: 407.5,
    y2: 416.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.75,
    y1: 434.97,
    x2: 413.16,
    y2: 430.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.55,431.57a5.2,5.2,0,0,0-1.83-3.89c-1.18-1.06-7.38-3.66-8-1.48C404.12,428.58,410.46,433.24,414.55,431.57Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.55,
    y1: 431.57,
    x2: 408.65,
    y2: 427.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.78,
    y1: 397.01,
    x2: 409.19,
    y2: 392.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.59,393.61a5.2,5.2,0,0,0-1.83-3.89c-1.18-1.05-7.38-3.66-8-1.48C400.15,390.62,406.5,395.28,410.59,393.61Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.59,
    y1: 393.61,
    x2: 404.69,
    y2: 389.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.94,
    y1: 408.04,
    x2: 410.35,
    y2: 403.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,404.65a5.21,5.21,0,0,0-1.83-3.9c-1.18-1.05-7.38-3.66-8-1.47C401.31,401.65,407.65,406.32,411.74,404.65Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.74,
    y1: 404.65,
    x2: 405.84,
    y2: 400.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.91,
    y1: 379.08,
    x2: 407.32,
    y2: 374.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.72,375.69a5.21,5.21,0,0,0-1.83-3.9c-1.18-1.05-7.38-3.66-8-1.47C398.28,372.69,404.63,377.36,408.72,375.69Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.72,
    y1: 375.69,
    x2: 402.81,
    y2: 372.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.03,
    y1: 361.08,
    x2: 405.44,
    y2: 356.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.84,357.69a5.21,5.21,0,0,0-1.83-3.9c-1.18-1.05-7.38-3.66-8-1.47C396.4,354.69,402.75,359.36,406.84,357.69Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.84,
    y1: 357.69,
    x2: 400.94,
    y2: 354.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.82,
    y1: 417.4,
    x2: 419.31,
    y2: 411.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.25,413.42a5.22,5.22,0,0,1,1-4.19c.94-1.27,6.47-5.1,7.49-3.09C427.84,408.34,422.59,414.21,418.25,413.42Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.25,
    y1: 413.42,
    x2: 423.56,
    y2: 408.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.79,
    y1: 388.37,
    x2: 416.28,
    y2: 382.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.22,384.39a5.21,5.21,0,0,1,1-4.19c.94-1.27,6.47-5.11,7.49-3.09C424.81,379.3,419.56,385.17,415.22,384.39Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.22,
    y1: 384.39,
    x2: 420.53,
    y2: 379.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.46,
    y1: 375.61,
    x2: 414.95,
    y2: 369.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.89,371.62a5.15,5.15,0,0,1,1-4.18c.94-1.27,6.46-5.11,7.49-3.09C423.48,366.54,418.23,372.41,413.89,371.62Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.89,
    y1: 371.63,
    x2: 419.2,
    y2: 366.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.51,
    y1: 356.9,
    x2: 413,
    y2: 351.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,352.92a5.2,5.2,0,0,1,1-4.19c.93-1.27,6.46-5.1,7.49-3.09C421.52,347.83,416.28,353.71,411.93,352.92Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.93,
    y1: 352.92,
    x2: 417.25,
    y2: 347.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,344.94a5.17,5.17,0,0,1,1-4.19c.93-1.27,6.46-5.1,7.49-3.09C417.61,339.86,412.36,345.73,408,344.94Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.02,
    y1: 344.94,
    x2: 413.33,
    y2: 339.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.32,345.16a5.2,5.2,0,0,1-4.06-1.42c-1.16-1.06-4.4-7-2.28-7.77C404.27,335.09,409.56,340.92,408.32,345.16Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.32,
    y1: 345.16,
    x2: 403.83,
    y2: 339.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 434.81,
    y1: 358.84,
    x2: 424.74,
    y2: 455.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.96,
    y1: 437.36,
    x2: 423.47,
    y2: 431.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.54,433.38a5.2,5.2,0,0,0-1-4.19c-.94-1.27-6.47-5.1-7.49-3.08C414.94,428.3,420.19,434.17,424.54,433.38Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.54,
    y1: 433.38,
    x2: 419.52,
    y2: 428.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.76,
    y1: 410.43,
    x2: 426.26,
    y2: 404.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.33,406.45a5.18,5.18,0,0,0-1-4.18c-.93-1.27-6.46-5.1-7.49-3.09C417.74,401.37,423,407.25,427.33,406.45Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.33,
    y1: 406.45,
    x2: 422.31,
    y2: 401.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 428.61,
    y1: 421.47,
    x2: 425.12,
    y2: 415.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.19,417.49a5.2,5.2,0,0,0-1-4.19c-.94-1.27-6.47-5.1-7.49-3.08C416.59,412.41,421.84,418.28,426.19,417.49Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.19,
    y1: 417.49,
    x2: 421.17,
    y2: 412.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.62,
    y1: 392.51,
    x2: 428.12,
    y2: 386.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.19,388.53a5.2,5.2,0,0,0-1-4.19c-.93-1.27-6.46-5.1-7.49-3.08C419.6,383.45,424.85,389.32,429.19,388.53Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.19,
    y1: 388.53,
    x2: 424.17,
    y2: 383.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.49,
    y1: 374.51,
    x2: 429.99,
    y2: 368.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.06,370.53a5.2,5.2,0,0,0-1-4.19c-.93-1.27-6.46-5.1-7.49-3.09C421.46,365.45,426.71,371.32,431.06,370.53Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.06,
    y1: 370.53,
    x2: 426.04,
    y2: 365.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.55,
    y1: 430.81,
    x2: 432.14,
    y2: 425.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.75,427.42a5.18,5.18,0,0,1,1.82-3.9c1.18-1,7.38-3.66,8-1.48C441.18,424.41,434.84,429.08,430.75,427.42Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.75,
    y1: 427.42,
    x2: 436.99,
    y2: 423.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.57,
    y1: 401.78,
    x2: 435.15,
    y2: 396.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.76,398.38a5.22,5.22,0,0,1,1.82-3.9c1.18-1.05,7.38-3.66,8-1.48C444.19,395.38,437.85,400.05,433.76,398.38Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.76,
    y1: 398.38,
    x2: 440.01,
    y2: 394.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.89,
    y1: 389.01,
    x2: 436.48,
    y2: 384.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.08,385.62a5.21,5.21,0,0,1,1.83-3.9c1.18-1.05,7.38-3.66,8-1.48C445.52,382.62,439.17,387.28,435.08,385.62Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.08,
    y1: 385.62,
    x2: 441.33,
    y2: 381.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.83,
    y1: 370.31,
    x2: 438.42,
    y2: 365.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,366.91a5.19,5.19,0,0,1,1.82-3.9c1.18-1.05,7.38-3.66,8-1.48C447.46,363.91,441.11,368.58,437,366.91Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.03,
    y1: 366.91,
    x2: 443.27,
    y2: 363.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.83,358.3a5.21,5.21,0,0,1,1.83-3.9c1.18-1,7.38-3.66,8-1.48C445.27,355.29,438.92,360,434.83,358.3Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 434.83,
    y1: 358.3,
    x2: 441.08,
    y2: 354.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.09,358.57a5.18,5.18,0,0,1-3.68-2.22c-.93-1.28-2.87-7.72-.64-8.08C433.2,347.88,437.18,354.68,435.09,358.57Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.09,
    y1: 358.57,
    x2: 431.89,
    y2: 351.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.27,
    y1: 319.33,
    x2: 423.27,
    y2: 442.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.37,
    y1: 423.58,
    x2: 419.3,
    y2: 418.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.54,419.87a5.21,5.21,0,0,0-1.41-4.06c-1.07-1.17-7-4.41-7.77-2.3C410.47,415.81,416.3,421.11,420.54,419.87Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.54,
    y1: 419.87,
    x2: 415.05,
    y2: 415.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.37,
    y1: 400.52,
    x2: 419.3,
    y2: 395.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.54,396.81a5.21,5.21,0,0,0-1.41-4.06c-1.07-1.17-7-4.41-7.77-2.3C410.47,392.75,416.3,398.05,420.54,396.81Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.54,
    y1: 396.81,
    x2: 415.05,
    y2: 392.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.37,
    y1: 373.45,
    x2: 419.3,
    y2: 368.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.54,369.74a5.21,5.21,0,0,0-1.41-4.06c-1.07-1.17-7-4.41-7.77-2.3C410.47,365.68,416.3,371,420.54,369.74Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.54,
    y1: 369.74,
    x2: 415.05,
    y2: 365.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.37,
    y1: 355.43,
    x2: 419.3,
    y2: 350.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.54,351.72a5.21,5.21,0,0,0-1.41-4.06c-1.07-1.17-7-4.41-7.77-2.3C410.47,347.66,416.3,353,420.54,351.72Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.54,
    y1: 351.72,
    x2: 415.05,
    y2: 347.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.37,
    y1: 337.33,
    x2: 419.3,
    y2: 332.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.54,333.62a5.21,5.21,0,0,0-1.41-4.06c-1.07-1.17-7-4.41-7.77-2.3C410.47,329.56,416.3,334.86,420.54,333.62Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.54,
    y1: 333.62,
    x2: 415.05,
    y2: 329.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.28,
    y1: 430.62,
    x2: 427.34,
    y2: 425.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1,426.91a5.2,5.2,0,0,1,1.42-4.06c1.06-1.17,7-4.41,7.77-2.3C436.17,422.85,430.34,428.15,426.1,426.91Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.1,
    y1: 426.91,
    x2: 431.92,
    y2: 422.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.28,
    y1: 393.95,
    x2: 427.34,
    y2: 388.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1,390.24a5.2,5.2,0,0,1,1.42-4.06c1.06-1.17,7-4.41,7.77-2.3C436.17,386.18,430.34,391.47,426.1,390.24Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.1,
    y1: 390.24,
    x2: 431.92,
    y2: 385.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.28,
    y1: 375.85,
    x2: 427.34,
    y2: 370.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1,372.14a5.2,5.2,0,0,1,1.42-4.06c1.06-1.17,7-4.41,7.77-2.3C436.17,368.08,430.34,373.37,426.1,372.14Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.1,
    y1: 372.14,
    x2: 431.92,
    y2: 367.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.28,
    y1: 351.92,
    x2: 427.34,
    y2: 346.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1,348.22a5.22,5.22,0,0,1,1.42-4.07c1.06-1.17,7-4.4,7.77-2.29C436.17,344.15,430.34,349.45,426.1,348.22Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.1,
    y1: 348.22,
    x2: 431.92,
    y2: 343.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.28,
    y1: 333.12,
    x2: 427.34,
    y2: 327.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1,329.41a5.22,5.22,0,0,1,1.42-4.07c1.06-1.16,7-4.4,7.77-2.29C436.17,325.34,430.34,330.64,426.1,329.41Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.1,
    y1: 329.41,
    x2: 431.92,
    y2: 324.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,321.07a5.22,5.22,0,0,1,1.42-4.07c1.06-1.17,7-4.4,7.77-2.29C433.1,317,427.27,322.3,423,321.07Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.03,
    y1: 321.07,
    x2: 428.85,
    y2: 316.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.32,321.32a5.22,5.22,0,0,1-3.89-1.84c-1.06-1.18-3.66-7.38-1.47-8C420.33,310.88,425,317.23,423.32,321.32Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.32,
    y1: 321.32,
    x2: 419.45,
    y2: 315.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.32 473.85 415.32 473.85 413.7 441.03 429.94 441.03 428.32 473.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "163.47 475.02 156.45 403.33 150.97 404.53 160.88 475.02 163.47 475.02",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.41 475.02 92.32 404.53 86.85 403.33 79.83 475.02 82.41 475.02",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.46,412l-3.52-83.84A8.78,8.78,0,0,1,93.72,319h58.74a8.79,8.79,0,0,1,8.76,9.47L154.71,412Z",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 393.61,
    width: 77.95,
    height: 18.37,
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.46,412h-5.9l-4.13-34.52a5,5,0,0,1,5-5h0a5,5,0,0,1,5,5Z",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.71,412h5.9l4.14-34.52a5,5,0,0,0-5-5h0a5,5,0,0,0-5,5Z",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.58,320.42H97.17a2.5,2.5,0,0,1,2.5,2.5v29.92a0,0,0,0,1,0,0H45.08a0,0,0,0,1,0,0V322.92A2.5,2.5,0,0,1,47.58,320.42Z",
    style: {
      fill: "#fff",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220 475.02 213.52 361.94 207.98 361.94 217.48 475.02 220 475.02",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.38 475.02 233.9 361.94 228.35 361.94 237.85 475.02 240.38 475.02",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.62 475.02 68.71 361.94 63.18 361.94 58.12 475.02 60.62 475.02",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.83 475.02 45.91 361.94 40.39 361.94 35.33 475.02 37.83 475.02",
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.78,
    y: 355.56,
    width: 204.22,
    height: 9.89,
    style: {
      fill: "#fff",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.78,
    y: 355.56,
    width: 204.22,
    height: 3.39,
    style: {
      fill: "gray",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.71,
    y: 352.26,
    width: 210.36,
    height: 3.77,
    style: {
      fill: "#fff",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 39,
    width: 348,
    height: 272,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.28,
    y: 28.36,
    width: 349.05,
    height: 272.64,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.28,
    y: 28.36,
    width: 349.05,
    height: 272.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.68,
    y: 80.94,
    width: 325.35,
    height: 148.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 207.73,
    x2: 400.07,
    y2: 207.73,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 207.73,
    x2: 96.99,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.94,
    y1: 207.73,
    x2: 112.94,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.89,
    y1: 207.73,
    x2: 128.89,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.84,
    y1: 207.73,
    x2: 144.84,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.79,
    y1: 207.73,
    x2: 160.79,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.74,
    y1: 207.73,
    x2: 176.74,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.7,
    y1: 207.73,
    x2: 192.7,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.65,
    y1: 207.73,
    x2: 208.65,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.6,
    y1: 207.73,
    x2: 224.6,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.55,
    y1: 207.73,
    x2: 240.55,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.5,
    y1: 207.73,
    x2: 256.5,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.45,
    y1: 207.73,
    x2: 272.45,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.41,
    y1: 207.73,
    x2: 288.41,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.36,
    y1: 207.73,
    x2: 304.36,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.31,
    y1: 207.73,
    x2: 320.31,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.26,
    y1: 207.73,
    x2: 336.26,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.21,
    y1: 207.73,
    x2: 352.21,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.16,
    y1: 207.73,
    x2: 368.16,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.11,
    y1: 207.73,
    x2: 384.11,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.07,
    y1: 207.73,
    x2: 400.07,
    y2: 204.76,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 207.73,
    x2: 96.99,
    y2: 88.85,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 207.73,
    x2: 104.56,
    y2: 207.73,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 183.96,
    x2: 88.62,
    y2: 183.96,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 160.18,
    x2: 88.62,
    y2: 160.18,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 136.4,
    x2: 88.62,
    y2: 136.4,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 112.63,
    x2: 88.62,
    y2: 112.63,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 88.85,
    x2: 88.62,
    y2: 88.85,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.14,
    y1: 112.63,
    x2: 392.09,
    y2: 94.62,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.19,
    y1: 153.05,
    x2: 376.14,
    y2: 112.63,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.24,
    y1: 136.4,
    x2: 360.19,
    y2: 153.05,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.28,
    y1: 179.2,
    x2: 344.24,
    y2: 136.4,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.33,
    y1: 112.63,
    x2: 328.28,
    y2: 179.2,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.38,
    y1: 88.85,
    x2: 312.33,
    y2: 112.63,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.43,
    y1: 195.85,
    x2: 296.38,
    y2: 88.85,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.48,
    y1: 188.71,
    x2: 280.43,
    y2: 195.85,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.53,
    y1: 186.33,
    x2: 264.48,
    y2: 188.71,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.57,
    y1: 139.2,
    x2: 248.53,
    y2: 186.33,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.62,
    y1: 129.69,
    x2: 232.57,
    y2: 139.2,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.67,
    y1: 174.45,
    x2: 216.62,
    y2: 129.69,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.72,
    y1: 183.96,
    x2: 200.67,
    y2: 174.45,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.77,
    y1: 134.03,
    x2: 184.72,
    y2: 183.96,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.82,
    y1: 126.89,
    x2: 168.77,
    y2: 134.03,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.87,
    y1: 117.38,
    x2: 152.82,
    y2: 126.89,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.91,
    y1: 126.89,
    x2: 136.87,
    y2: 117.38,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.96,
    y1: 136.4,
    x2: 120.91,
    y2: 126.89,
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.09,91.8h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,392.09,91.8Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.14,109.81h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,376.14,109.81Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,150.23h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.83,2.83,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,360.19,150.23Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.24,133.58h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.81,2.81,0,0,0,2.81-2.82h0A2.82,2.82,0,0,0,344.24,133.58Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.28,176.38h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,328.28,176.38Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.33,109.81h0a2.82,2.82,0,0,0-2.82,2.82h0a2.83,2.83,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,312.33,109.81Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,86h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,296.38,86Z",
    style: {
      fill: "#263238",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.43,193h0a2.82,2.82,0,0,0-2.82,2.82h0a2.81,2.81,0,0,0,2.82,2.81h0a2.81,2.81,0,0,0,2.82-2.81h0A2.82,2.82,0,0,0,280.43,193Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.48,185.89h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.83,2.83,0,0,0,264.48,185.89Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53,183.52h0a2.81,2.81,0,0,0-2.82,2.81h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,248.53,183.52Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.57,136.38h0a2.81,2.81,0,0,0-2.81,2.82h0a2.81,2.81,0,0,0,2.81,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,232.57,136.38Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,126.87h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,216.62,126.87Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.67,171.63h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,200.67,171.63Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.72,181.14h0A2.82,2.82,0,0,0,181.9,184h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,184.72,181.14Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,131.21h0A2.82,2.82,0,0,0,166,134h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,168.77,131.21Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.82,124.07h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.83,2.83,0,0,0,152.82,124.07Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,114.56h0a2.82,2.82,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.81,2.81,0,0,0,2.81-2.82h0A2.82,2.82,0,0,0,136.87,114.56Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.91,124.07h0a2.83,2.83,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,120.91,124.07Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,133.58h0a2.83,2.83,0,0,0-2.82,2.82h0a2.82,2.82,0,0,0,2.82,2.82h0a2.82,2.82,0,0,0,2.82-2.82h0A2.82,2.82,0,0,0,105,133.58Z",
    style: {
      fill: "#fff",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.31,
    y: 28.36,
    width: 9.02,
    height: 272.64,
    style: {
      fill: "#dbdbdb",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.31,
    y: 112.83,
    width: 9.02,
    height: 73.67,
    style: {
      fill: "#878787"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.28,
    y: 28.36,
    width: 349.05,
    height: 17.71,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.28,51.45h87.63a2,2,0,0,1,2,2V63.63a2,2,0,0,1-2,2H78.28a0,0,0,0,1,0,0V51.45A0,0,0,0,1,78.28,51.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.32,59.63l.93-6.14h1.88v8.65H93.85v-6.2l-.94,6.2H91.63l-1-6.11v6.11H89.43V53.49h1.89Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.52,62.14H99.15l-.23-1.57H97.25L97,62.14H95.77l1.38-8.65h2Zm-3.1-2.74h1.31L98.08,55Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,62.14a2.77,2.77,0,0,1-.12-1.06V59.72c0-.8-.27-1.1-.89-1.1h-.47v3.52h-1.36V53.49h2c1.41,0,2,.66,2,2v.68a1.75,1.75,0,0,1-.89,1.76c.68.28.9.93.9,1.84v1.33a2.48,2.48,0,0,0,.15,1Zm-1.48-7.41v2.65H103c.51,0,.82-.22.82-.91v-.85c0-.62-.21-.89-.69-.89Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.06,58.92v1.14c0,1.39-.69,2.18-2,2.18s-2-.79-2-2.18V55.57c0-1.38.69-2.17,2-2.17a1.89,1.89,0,0,1,2,2.17v.84h-1.28v-.93c0-.61-.28-.85-.71-.85s-.7.24-.7.85v4.67c0,.62.27.84.7.84s.71-.22.71-.84V58.92Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25,62.14h-1.36V53.49h1.36V57.2h1.54V53.49h1.38v8.65h-1.38V58.43h-1.54Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.24,
    y: 31.38,
    width: 224.41,
    height: 9.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.16,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.13,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.1,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.07,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.05,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.02,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.99,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.96,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.93,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.9,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.87,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.81,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.79,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.76,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.73,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.7,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.67,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.64,
    y: 211,
    width: 15.18,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.29,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.49,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.9,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.1,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.31,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.51,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.71,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.92,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.12,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.32,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.53,
    y: 71.31,
    width: 25.86,
    height: 6.98,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.27,88.88h53.27L278.31,95v12.48A3.32,3.32,0,0,1,275,110.8H237.27a3.32,3.32,0,0,1-3.31-3.32V92.19A3.31,3.31,0,0,1,237.27,88.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.73,96.08c0-1.27-.44-1.61-1.15-1.61s-1.15.38-1.15,1.39v.91h-2.1V96c0-2.26,1.13-3.55,3.31-3.55S251,93.74,251,96v.37c0,1.51-.48,2.46-1.55,2.9,1.11.49,1.55,1.54,1.55,3v1.11c0,2.26-1.13,3.56-3.31,3.56s-3.31-1.3-3.31-3.56v-1.17h2.1v1.31c0,1,.44,1.4,1.15,1.4s1.15-.35,1.15-1.6v-1.11c0-1.31-.44-1.8-1.45-1.8h-.75v-2h.87c.83,0,1.33-.36,1.33-1.49Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.26,96c0-2.26,1.2-3.55,3.38-3.55S259,93.74,259,96v7.35c0,2.26-1.19,3.56-3.37,3.56s-3.38-1.3-3.38-3.56Zm2.23,7.49c0,1,.44,1.4,1.15,1.4s1.15-.39,1.15-1.4V95.86c0-1-.45-1.39-1.15-1.39s-1.15.38-1.15,1.39Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.35,101.11l-.69,1.29v4.35h-2.22V92.61h2.22v6.16l2.91-6.16h2.22l-3.09,6.3,3.09,7.84h-2.28Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,260.35v1.18c0,.9.39,1.23,1,1.23s1-.33,1-1.23v-2.79c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25v.38h-1.89l.37-7.35h5.25v1.81h-3.46l-.16,3a1.9,1.9,0,0,1,1.73-.92c1.47,0,2.21,1,2.21,2.9v2.82c0,2-1,3.19-3,3.19s-3-1.16-3-3.19v-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16,254.81c0-2,1.07-3.18,3-3.18s3,1.15,3,3.18v6.59c0,2-1.07,3.19-3,3.19s-3-1.16-3-3.19Zm2,6.72c0,.9.4,1.25,1,1.25s1-.35,1-1.25v-6.84c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,254.81c0-2,1.07-3.18,3-3.18s3,1.15,3,3.18v6.59c0,2-1.07,3.19-3,3.19s-3-1.16-3-3.19Zm2,6.72c0,.9.4,1.25,1,1.25s1-.35,1-1.25v-6.84c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,259.39l-.61,1.16v3.89h-2V251.77h2v5.52l2.61-5.52h2l-2.77,5.65,2.77,7h-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.42,
    y1: 273.3,
    x2: 151.45,
    y2: 273.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,260.35v1.18c0,.9.4,1.23,1,1.23s1-.33,1-1.23v-2.79c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25v.38h-1.88l.36-7.35h5.25v1.81h-3.46l-.16,3a1.91,1.91,0,0,1,1.74-.92c1.46,0,2.21,1,2.21,2.9v2.82c0,2-1,3.19-3,3.19s-3-1.16-3-3.19v-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.17,254.81c0-2,1.07-3.18,3-3.18s3,1.15,3,3.18v6.59c0,2-1.06,3.19-3,3.19s-3-1.16-3-3.19Zm2,6.72c0,.9.4,1.25,1,1.25s1-.35,1-1.25v-6.84c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.34,254.81c0-2,1.07-3.18,3-3.18s3,1.15,3,3.18v6.59c0,2-1.06,3.19-3,3.19s-3-1.16-3-3.19Zm2,6.72c0,.9.4,1.25,1,1.25s1-.35,1-1.25v-6.84c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.28,259.39l-.62,1.16v3.89h-2V251.77h2v5.52l2.61-5.52h2l-2.77,5.65,2.77,7h-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.42,
    y1: 273.3,
    x2: 260.46,
    y2: 273.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.31,260.35v1.18c0,.9.4,1.23,1,1.23s1-.33,1-1.23v-2.79c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25v.38h-1.89l.37-7.35H356v1.81h-3.46l-.16,3a1.9,1.9,0,0,1,1.73-.92c1.47,0,2.21,1,2.21,2.9v2.82c0,2-1,3.19-3,3.19s-3-1.16-3-3.19v-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.52,254.81c0-2,1.07-3.18,3-3.18s3,1.15,3,3.18v6.59c0,2-1.07,3.19-3,3.19s-3-1.16-3-3.19Zm2,6.72c0,.9.4,1.25,1,1.25s1-.35,1-1.25v-6.84c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.7,254.81c0-2,1.06-3.18,3-3.18s3,1.15,3,3.18v6.59c0,2-1.07,3.19-3,3.19s-3-1.16-3-3.19Zm2,6.72c0,.9.39,1.25,1,1.25s1-.35,1-1.25v-6.84c0-.91-.4-1.25-1-1.25s-1,.34-1,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,259.39l-.61,1.16v3.89h-2V251.77h2v5.52l2.61-5.52h2l-2.77,5.65,2.77,7h-2.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.78,
    y1: 273.3,
    x2: 378.82,
    y2: 273.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.06,
    y1: 240.99,
    x2: 193.06,
    y2: 276.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.62,
    y1: 240.99,
    x2: 311.62,
    y2: 276.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.82,235.3h3.53v1h-1.2v6.22H128v-6.22h-1.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75,237a1.74,1.74,0,1,1,3.47,0v3.78a1.74,1.74,0,1,1-3.47,0Zm1.14,3.85c0,.52.23.72.59.72s.6-.2.6-.72V237c0-.52-.23-.72-.6-.72s-.59.2-.59.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,235.3h1.81c1.14,0,1.7.63,1.7,1.79v3.68c0,1.16-.56,1.79-1.7,1.79H135Zm1.15,1v5.19h.64c.36,0,.58-.19.58-.71V237c0-.52-.22-.7-.58-.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.87,242.56h-1.15l-.2-1.31h-1.4l-.2,1.31h-1L140,235.3h1.67Zm-2.6-2.3h1.1l-.55-3.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.47,240.16,143,235.3h1.2l.87,3.31.87-3.31h1.09l-1.44,4.86v2.4h-1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,238.69l-.41,3.87H238l-.81-7.26h1.11l.62,5.73.55-5.73h1.1l.57,5.77.59-5.77h1l-.81,7.26h-1.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,238.36H246v1h-1.56v2.13h2v1h-3.12V235.3h3.12v1h-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.24,238.36h1.57v1h-1.57v2.13h2v1H247.1V235.3h3.12v1h-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.41,239.67l-.35.66v2.23h-1.14V235.3h1.14v3.16l1.5-3.16h1.14l-1.59,3.24,1.59,4h-1.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,240.46l.77-5.16h1.59v7.26h-1.08v-5.21l-.79,5.21h-1.07l-.86-5.13v5.13h-1V235.3h1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,237a1.73,1.73,0,1,1,3.46,0v3.78a1.73,1.73,0,1,1-3.46,0Zm1.14,3.85c0,.52.23.72.59.72s.59-.2.59-.72V237c0-.52-.23-.72-.59-.72s-.59.2-.59.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.32,237.3v5.26h-1V235.3h1.43l1.17,4.35V235.3h1v7.26h-1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.4,235.3h3.53v1h-1.2v6.22h-1.14v-6.22H367.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.56,242.56h-1.14V235.3h1.14v3.11h1.3V235.3H375v7.26h-1.16v-3.11h-1.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.33,
    y1: 52.33,
    x2: 393,
    y2: 52.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.33,
    y1: 57.67,
    x2: 393,
    y2: 57.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.33,
    y1: 63,
    x2: 393,
    y2: 63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 270.74,
    width: 51.35,
    height: 33.78,
    transform: "translate(27.66 -22.29) rotate(5.3)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "234.08 290.41 240.17 281.79 245.75 283.31 250.83 292.44 259.96 283.82 265.55 296 269.1 296 277.73 281.79",
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,284.14a34.62,34.62,0,0,0-5.67-4.53c-4-2.75-6.31-3.24-7-2.91s-6,5.34-6.15,7.12-1,3.4-1,4.05,1.13.16,2.26-.65,2-3.56,2.43-4.05,3.4-.65,3.89-.65,1.13,2.76,1.13,2.76.32,4.53,1.78,5.18,6.8.48,6.8.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.89,
    y1: 277.34,
    x2: 257.71,
    y2: 291.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.09,283.82l-3.24,2.59c-.81.65-6.15,1.62-6.8,1.94s-2.43.81-1.29,1.46,4.21,1,5.5,1,5,1.3,6.64.49l2.91-1.46",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.52 283.5 280.05 282.85 278.75 292.07 286.52 294.18 286.52 283.5",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.1,218.81s-.68,5,.68,7a13.69,13.69,0,0,1,1.81,3.85S293.1,237.59,294,238a14.62,14.62,0,0,0,3.4.68s3.39,7.47,4.52,8.15a8.27,8.27,0,0,0,2,.9l2,1.59,17.65-8.15-2.94-8.37a23.69,23.69,0,0,1,0-8.83c.9-5-6.34-11.09-11.09-12.45s-12.67.68-12.67.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.21,207.94s-9.5,5.44-9.28,8.38a8.73,8.73,0,0,0,2.26,5L297,219s-2,3.62-.91,4.08a2,2,0,0,0,2-.46l1.36,4.3,2.94-2.49s5,11.32,8.37,11.77,8.6-.23,10.41-1.36,4.3-11.76,5.2-15.84-3.84-11.76-10.41-14-15.84,2.49-15.84,2.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.79,224.69a18,18,0,0,1,1.81,4.53c1.14,3.62,2.27,8.82,2.95,2.94S302.15,220.62,300.79,224.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.37,466.14s-3.62,4.75-4.3,5-7.24,2.26-7.47,3.62a4.33,4.33,0,0,0,.68,2.72,55.26,55.26,0,0,0,11.09,1.35,87,87,0,0,0,11.31-.9,41.43,41.43,0,0,0,7.7,0c2.49-.45,2.71-2,2.71-2l-1.36-12.67-14.93.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.63,466.37l-5.43,6.33s-2.49.68-2.26,2.95,2.71,2.49,5,2.49,16.74.45,19-.68-2-12.45-2-12.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.05,341s-.45,36.89-.23,45,2.94,55.9,3.17,60,.45,10,.45,10-1.58,2.49-1.58,3.62v3.85s7.47,7.46,11.31,7.46,10.41-2.26,10.41-2.26,1.81-11.54,2.27-13.58S308,420.2,308,419.53s-1.13-14.26-1.13-15.17,5.66,30.1,5.89,34.4,2.94,19,2.94,19a3.57,3.57,0,0,0-1.36,3.17c.23,2,.45,6.33.45,6.33a13.3,13.3,0,0,0,7,3.17,68.57,68.57,0,0,0,9.73.68c.9,0,2.94.23,3.62-1.36s.23-13.58.23-15.84-.91-8.37-.91-9.95-4.07-42.77-3.85-52.28.23-32.13,1.14-34.17,4.07-14.71,4.07-17-11.32,5.21-25.35,3.62a252.79,252.79,0,0,1-26.47-4.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.58,353.45l-7.25,5.43s-2.48,30.55-3.62,36-1.58,7-1.58,7",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08,304.34s-8.15-4.3-10-4.52-7.69.68-7.69.68-4.08-1.81-5.66-.46-.68,1.59.45,2,6.79,1.59,6.79,1.59-1.36,4.29-.68,5,4.75.91,4.75.91a14.93,14.93,0,0,1,2.49,1.36c1.36.9,5,.68,5.66.22s2-1.13,2-1.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.38,251.62l3.62-5.21s9.95-6.33,14-7.24,10.41,5.21,10.41,5.21-3.62.68-12,3.17S302.38,251.62,302.38,251.62Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,249.36s-18.78,7-19,10.86-3.17,51.59-3.17,51.59l-3.62,31.68s12.22,6.11,24.21,6.56,18.11.23,22.41-1.35,13.57-9.05,13.57-9.05-5-28.06-5-31.46,7.69-28.06,9.27-35.3A112.49,112.49,0,0,0,347,253.2c0-3.39-18.33-8.82-18.33-8.82S316.63,245.06,306,249.36Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.48,277.61c-3,6-7.84,15.46-11.77,20.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.19,272s-.51,1.1-1.36,2.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9,299.21c-1.94,2.68-3.9,5.38-4.23,5.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,293.48s-1.4,1.95-3.07,4.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.7,
    y1: 290.99,
    x2: 308.71,
    y2: 275.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.89,
    y1: 294.39,
    x2: 308.03,
    y2: 285.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,252.52s-12,4.08-12.22,5.43-3.62,47.3-3.62,47.3l-17.2-2a10.06,10.06,0,0,0-1.58,5.21v5.43s2.26.22,10,3.17,16.74,4.75,18.78,4.52,6.34-6.79,6.34-10.41,5.88-36.88,5.88-36.88",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,312.59l-.83-7.34s-1.73,5.29-1.47,7.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.97 235.92 174.73 244.02 195.5 251.41 195.5 244.19 189.69 216.92 176.14 225.72 175.97 235.92",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.07,212.17s.17,7.56.17,9.15a15.43,15.43,0,0,1-1.23,4.4s1.76,3.87,2.11,4.92-2.11,2.82-2.11,2.82-.35,3.17-.53,3.69a4.15,4.15,0,0,1-4.92,1.76c-2.64-1-5.28-10.73-5.64-13.9s-.17-10,3.35-12.49S203.07,212.17,203.07,212.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33,225.36s4.58-2.63,5.1-3.69-.17-3.7-.52-6,4.75-2.64,6.16-1.94,3.52,1.94,3.52-2.64S202,200.2,191.8,200.55s-20.06,3.17-22.34,14.08,3.51,20.06,4.22,21.64,4.75,4.23,10,.71,4-8.1,4-8.1,0-3,.88-3,1.05.88,1.05,7.57-.17,12.32,3.87,13.73,8.27-.71,8.63-4.76-.36-7.21-2.12-7.21-2.81,2.64-4.57-1.58S192.33,225.36,192.33,225.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87,227.83s.35-9-2.82-5.1.53,9.67.53,9.67l1.06-1.76",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.62,240,168,248.5s9.37-1.14,16.41,1.15,13.38,4.75,13.38,4.75L195.32,246s-7.74-3.69-14.07-4.75S172.62,240,172.62,240Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08,465.94s3.62,4.75,4.3,5,7.24,2.26,7.47,3.62a4.38,4.38,0,0,1-.68,2.71,54.88,54.88,0,0,1-11.09,1.36,86,86,0,0,1-11.31-.91,40.53,40.53,0,0,1-7.7,0c-2.49-.45-2.71-2-2.71-2L184.71,463l14.94.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,466.16l5.43,6.34s2.49.68,2.26,2.94-2.72,2.49-5,2.49-16.74.45-19-.68,2-12.44,2-12.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.56,342.13s1.22,14.27,1.81,15.84c.68,1.82,2.94,47.75.68,54.09s-4.07,18.78-3.17,23.76a111.89,111.89,0,0,1,1.36,13.8c0,1.36-2.72,9.53-2.72,12.92a27,27,0,0,0,.91,6.57s7.24.45,10.86-.68,5.88-1.59,5.88-1.59l1.59,1.13v-9.73c0-3.62,1.78-10.62,1.78-12.88s1.85-20.92,3.21-25.67,2.93-32.3,2.93-32.3.45,36.21,0,40.28-1.36,5.89,0,10.86.9,22.2.9,22.2a9.27,9.27,0,0,0,0,3.62c.45,1.13,1.13,4.08,1.13,4.08a32.83,32.83,0,0,0,5.21.45c4.52.23,11.77.45,12.44.23s3.17-.91,3.17-.91a29,29,0,0,0,0-5c-.22-2.94-2-9.3-2.26-16.54s5.2-51.14,6.56-63.13,6.34-22.86,5.43-30.78-4.75-14.93-5-16.52-1.81-2.49-1.81-3.17-51.36,1.81-51.36,1.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "173.4 356.62 182 364.31 182.68 387.39",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,245.07s-19.54,12-19.54,14.43-1.4,27.1.71,35.9,6,19.53,6,19.53L153,346s4.88,3.5,18.79,7,26,2.94,27.55,2.58L199,348l5.63-16.72s7.21-10.91,7.74-14.43-.17-9-.53-12-2.81-14.78-3.69-17.77-1.41-24.46-3.52-26.92a51.69,51.69,0,0,0-8.45-7c-1.4-.88-13.55-9.68-23.4-8.45",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,303.36c.7.7,1.39,1.34,2.06,1.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24,285.49a147.36,147.36,0,0,0,12.58,16.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.56,310.83a13.57,13.57,0,0,0,4.54.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,303.67a37.84,37.84,0,0,0,6.78,5.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,330.6a43.35,43.35,0,0,1-9.67,12c-6.52,5.63-8.63,7.75-8.63,7.75s11.09.35,12.14,2.81l1.06,2.46Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.53,343.62l5.45,10.2s3.7-5.1,2.12-9.5-2.12-5.81-2.12-5.81Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.76,277.63s3.34,41,6.51,48.57,10.91,19.18,10.91,19.18,4.4-1.23,5.8-3,1.76-5.63,1.76-5.63-.88-15.31-.88-18.66-3.16-22-3.16-24.46.53-27.63-.71-31-10.73-6.16-10.73-6.16",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg11);
export default __webpack_public_path__ + "static/media/img11.a201f9d2daf34b7c86d7649a81df63a3.svg";
export { ForwardRef as ReactComponent };